// Canonical horizontal gutter for table-based Settings subsections, so the
// header, tabs, filters, headline and table all share one left/right edge.
// lg is 40px per the Figma; md kept the px-6 the filter bars used before
// they moved onto this constant. Applied (via `useSettingsTableGutter`) on
// top of components that ship their own base padding, so it wins via twMerge.
export const SETTINGS_TABLE_GUTTER = "px-4 md:px-6 lg:px-10";

// Mobile shell owns its own horizontal padding (see Mobile/README.md), so
// below lg the gutter drops to px-0 to avoid doubling up.
const SETTINGS_TABLE_GUTTER_MOBILE_FIRST = "px-0 lg:px-10";

// The bounded flex-column every wrapper between `SettingsTableContainer` and the
// table must use so the table owns its scroll and keeps its footer in view. Use
// `useSettingsTableFill()` to apply it only when the table layout is on.
export const SETTINGS_TABLE_FILL = "flex min-h-0 flex-1 flex-col";

// Canonical page size for Settings list tables. With `fillHeight` on, a page must
// hold enough rows to fill a typical viewport, otherwise the table pins its footer
// to the bottom and leaves a gap above it. 20 is the de-facto default across
// Settings; new tables should import this rather than redeclare a `DEFAULT_PAGE_SIZE`.
export const SETTINGS_TABLE_PAGE_SIZE = 20;

// The AppShell table layout ships with Circle 4.0, which is on for every
// community. Kept as a hook so call sites can drop their legacy branches
// separately.
export const useSettingsTableLayoutEnabled = () => true;

// The gutter class for table-layout subsections. Use it for any element that
// must share the table's left/right edge - the header, tabs, filters, headline
// and table - so they stay aligned.
export const useSettingsTableGutter = () => SETTINGS_TABLE_GUTTER_MOBILE_FIRST;

// The bounded fill class for table-layout subsections, so the table's scroll
// wrappers fill the shell.
export const useSettingsTableFill = () => SETTINGS_TABLE_FILL;
